import { useEffect } from 'react';

interface Props {
  initRules: () => void;
  getTagsHandler: () => Promise<void>;
}

export const useIntegrationParsingEffects = ({
  initRules,
  getTagsHandler,
}: Props) => {
  useEffect(() => {
    initRules();
  }, [initRules]);

  useEffect(() => {
    getTagsHandler();
  }, [getTagsHandler]);
};
